<template>
  <svg
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      width="16"
      height="16"
      rx="8"
      fill="#03C76B"
    />
    <path
      d="M5.7002 8.52617C5.7002 8.52617 6.8202 9.16494 7.3802 10.1012C7.3802 10.1012 9.0602 6.42617 11.3002 5.20117"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
